import { render, staticRenderFns } from "./ActionImprovementProblem.vue?vue&type=template&id=406bc654&scoped=true"
import script from "./ActionImprovementProblem.vue?vue&type=script&lang=js"
export * from "./ActionImprovementProblem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406bc654",
  null
  
)

export default component.exports